import { render, staticRenderFns } from "./ReportsGroupsList.vue?vue&type=template&id=41529b54"
import script from "./ReportsGroupsList.vue?vue&type=script&lang=js"
export * from "./ReportsGroupsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports